import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ContractSignatureSession, ContractSignatureSessionProgress, OrderCreate } from '@models/index';
import { EndpointParams } from '@models/utils/endpoint-params';

import { HttpService } from '@services/http.service';

// Lado de socio de la sesion de firma: abrirla desde el carrito y vigilar su estado. La ceremonia
// en si es publica y va por `PublicContractSignatureSessionService`.
//
// No confundir con `MemberContractService` (contratos de cuotas ya vendidas) ni con
// `PublicContractSignatureService` (la solicitud de firma por email, que sigue viva y caduca a 30
// dias); esta sesion bloquea la venta y caduca a 24 h.
@Injectable({
    providedIn: 'root'
})
export class ContractSignatureSessionService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'payments', version: 1 };

    // Se manda el MISMO cuerpo que va a ir despues a la compra: el backend reverifica que el
    // carrito firmado es identico al que se compra.
    //
    // Solo se llama cuando alguna linea lo exige: quien lo decide es el carrito, mirando
    // `requiresContractSignature` de cada tarifa. Llamar sin necesitarlo responde 400.
    create(cart: OrderCreate): Observable<ContractSignatureSession> {
        return this.post('customer/contract-signature-sessions', this.defaultEndpointParams, { cart }).pipe(map((response) => new ContractSignatureSession().build(response)));
    }

    // El enlace de pago es un carrito preconstruido por el staff: el backend lo conoce por el codigo
    // del enlace y firma ESE carrito, asi que aqui no viaja ninguno.
    createFromPaymentLink(link: string): Observable<ContractSignatureSession> {
        return this.post('customer/contract-signature-sessions/payment-link', this.defaultEndpointParams, { link }).pipe(map((response) => new ContractSignatureSession().build(response)));
    }

    // Sondeo del estado. Es la unica salida si el hub de SignalR no llega, asi que no es opcional.
    searchProgress(guid: string): Observable<ContractSignatureSessionProgress> {
        return this.get(`customer/contract-signature-sessions/${guid}`, this.defaultEndpointParams).pipe(map((response) => new ContractSignatureSessionProgress().build(response)));
    }
}
